function Loading() {
    return (
        <div>
            <span>Carregando...</span>
        </div>
    )
};

export default Loading;